module.exports = __webpack_public_path__ + "img/03.明成祖手植柏（杨树田-摄）.c6528556.jpg";